import { render, staticRenderFns } from "./StatsRedo.container.vue?vue&type=template&id=248c7261&scoped=true&"
import script from "./StatsRedo.container.vue?vue&type=script&lang=js&"
export * from "./StatsRedo.container.vue?vue&type=script&lang=js&"
import style0 from "./StatsRedo.container.vue?vue&type=style&index=0&id=248c7261&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248c7261",
  null
  
)

export default component.exports